import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiMail, FiPhone, FiMessageCircle } from "react-icons/fi";

const users = [
  {
    name: "Alexander Jermai",
    role: "UI/UX Designer",
    img: "/assets/img/users/user-27-1.jpg",
    icon: <FiMail />,
  },
  {
    name: "Doglas Martini",
    role: "Product Designer",
    img: "/assets/img/users/user-42-1.jpg",
    icon: <FiPhone />,
  },
  {
    name: "Daniel Esbella",
    role: "Project Manager",
    img: "/assets/img/users/user-43-1.jpg",
    icon: <FiMail />,
  },
  {
    name: "Daniel Esbella",
    role: "Team Lead",
    img: "/assets/img/users/user-11-1.jpg",
    icon: <FiMessageCircle />,
  },
  {
    name: "Stephan Peralt",
    role: "Team Lead",
    img: "/assets/img/users/user-44-1.jpg",
    icon: <FiMessageCircle />,
  },
];

export default function RecentFollowUp() {
  return (
    <Card className="rfu-card h-100 w-100">
      {/* HEADER */}
      <Card.Header className="rfu-header card-header-custom">
        <h5 className="rfu-title">Recent Follow Up</h5>
        <Button className="rfu-btn text-dark">View All</Button>
      </Card.Header>

      {/* BODY */}
      <Card.Body className="rfu-body">
        {users.map((u, i) => (
          <div key={i} className="rfu-row">
            {/* LEFT */}
            <div className="rfu-user">
              <img src={u.img} className="rfu-avatar" />
              <div className="ms-2">
                <h6 className="rfu-name">{u.name}</h6>
                <p className="rfu-role">{u.role}</p>
              </div>
            </div>

            {/* RIGHT ICON */}
            <div className="rfu-icon-box">{u.icon}</div>
          </div>
        ))}
      </Card.Body>

      {/* ✅ INLINE CSS */}
      <style>{`
        .rfu-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }


      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
        .rfu-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .rfu-title {
          font-weight: 600;
          margin: 0;
        }

        .rfu-btn {
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          font-size: 14px;
          padding: 6px 12px;

  
        }
               .rfu-btn:hover {
          
          border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
        }


        .rfu-body {
          padding-top: 10px;
        }

        .rfu-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 22px;
        }

        .rfu-user {
          display: flex;
          align-items: center;
        }

        .rfu-avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 2px solid #f3f4f6;
        }

        .rfu-name {
          font-size: 15px;
          font-weight: 500;
          margin-bottom: 2px;
        }

        .rfu-role {
          font-size: 13px;
          color: #6b7280;
          margin: 0;
        }

        /* ICON BOX EXACT */
        .rfu-icon-box {
          width: 36px;
          height: 36px;
          background: #f3f4f6;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #374151;
          cursor: pointer;
          transition: 0.2s;
        }

        .rfu-icon-box:hover {
          background: #fff4ed;
          color: #ff6a2c;
        }
      `}</style>
    </Card>
  );
}